import React from 'react';

export const WhyItMatters: React.FC = () => {
    const matters = [
        {
            icon: '🚀',
            title: 'DLMM pools offer powerful yield',
            description: 'But disappear fast'
        },
        {
            icon: '📈',
            title: 'APRs spike on early pools',
            description: 'Then vanish within hours'
        },
        {
            icon: '⏰',
            title: 'Timing matters',
            description: 'Enter within range, avoid IL, exit fast'
        },
        {
            icon: '🎯',
            title: 'Most bots are reactive',
            description: 'NyxBot is proactive'
        }
    ];

    const benefits = [
        { icon: '📈', text: 'Maximize reward windows' },
        { icon: '⚡', text: 'Strike pools before the crowd' },
        { icon: '😴', text: 'Wake up to LP returns' }
    ];

    return (
        <section className="py-24 bg-gradient-to-b from-black to-purple-900/10">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <span className="inline-block px-6 py-3 bg-purple-500/10 border border-purple-500/30 rounded-full text-purple-300 text-lg font-semibold mb-4">
                        💡 Why This Matters
                    </span>
                    <h2 className="text-5xl md:text-6xl font-bold text-white">
                        The edge you've been{' '}
                        <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
                            waiting for
                        </span>
                    </h2>
                </div>

                <div className="grid md:grid-cols-2 gap-6 mb-12">
                    {matters.map((matter, index) => (
                        <div
                            key={index}
                            className="flex items-start space-x-4 p-6 bg-black/40 border border-purple-500/20 rounded-xl hover:border-purple-500/40 transition-all"
                        >
                            <div className="text-3xl flex-shrink-0">{matter.icon}</div>
                            <div>
                                <h3 className="text-xl font-semibold text-white mb-1">{matter.title}</h3>
                                <p className="text-gray-400">{matter.description}</p>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="flex flex-wrap justify-center gap-6">
                    {benefits.map((benefit, index) => (
                        <div
                            key={index}
                            className="flex items-center space-x-2 px-6 py-3 bg-gradient-to-r from-purple-500/20 to-pink-500/20 border border-purple-500/30 rounded-full"
                        >
                            <span className="text-2xl">{benefit.icon}</span>
                            <span className="text-white font-medium">{benefit.text}</span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};